// @flow
export const DOMAIN = 'register_charity'

export const RESOURCES = {
  CREATE_CHARITY: 'register:charity:create',
  UPDATE_CHARITY: 'register:charity:update',
  REMOVE_CHARITY: 'register:charity:remove',
  FETCH_CHARITY: 'register:charity:fetch'
}

export const CREATE_CHARITY = {
  REQUEST: 'CREATE_CHARITY_REQUEST',
  SUCCESS: 'CREATE_CHARITY_SUCCESS',
  FAIL: 'CREATE_CHARITY_FAIL'
}

export const UPDATE_CHARITY = {
  REQUEST: 'UPDATE_CHARITY_REQUEST',
  SUCCESS: 'UPDATE_CHARITY_SUCCESS',
  FAIL: 'UPDATE_CHARITY_FAIL'
}

export const REMOVE_CHARITY = {
  REQUEST: 'REMOVE_CHARITY_REQUEST',
  SUCCESS: 'REMOVE_CHARITY_SUCCESS',
  FAIL: 'REMOVE_CHARITY_FAIL'
}

export const FETCH_CHARITY = {
  REQUEST: 'FETCH_CHARITY_REQUEST',
  SUCCESS: 'FETCH_CHARITY_SUCCESS',
  FAIL: 'FETCH_CHARITY_FAIL'
}



// WEBPACK FOOTER //
// ./src/services/register-charity/constants.js